import { useNavigate } from "react-router-dom";
import { Formik, FormikValues } from "formik";

import LoginForm from "./LoginForm";

import { useSignInMutation } from "../../../../generated/graphql";

import useAuthStore from "../../../../states/zustand/authStore";

import { loginValidationSchema } from "../utils";
import { logger } from "../../../../utils/logger";
import { setAccessToken } from "../../../../services/token";
import useAppStore from "../../../../states/zustand/appStore";
import { toast } from "react-toastify";

const LoginContainer = () => {
    const navigate = useNavigate();
    const [signInHandler] = useSignInMutation();
    const { setProfileData } = useAuthStore();
    const {setLoader} = useAppStore();

    const saveHandler = async (values: FormikValues) => {
        try {
            setLoader(true)
            const res: any = await signInHandler({ variables: { email: values.email, password: values.password } });
            setProfileData(res?.data?.signin?.user);
            setAccessToken(res?.data?.signin?.token);
            navigate("/");

        } catch (err: any) {
            toast.error("Email or password is incorrect")
            logger.error(err);
        } finally {
            setLoader(false)
        }
    }

    return (
        <Formik
            initialValues={{ email: '', password: '' }}
            validationSchema={loginValidationSchema}
            onSubmit={(values, { setSubmitting }) => {
                saveHandler(values);
            }}
        >
            <LoginForm />
        </Formik>
    )
}

export default LoginContainer;